import { render, staticRenderFns } from "./InventoryListComponent.vue?vue&type=template&id=a2166baa&"
import script from "./InventoryListComponent.vue?vue&type=script&lang=js&"
export * from "./InventoryListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports